/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../../js/features/dashboard/dashboardPreferences/DashboardPreferencesAPI'
], function(APIFactory, DashboardPreferencesAPI) {
	class CADashboardPreferences {

		constructor() {
			this._preferences = {};
			this._dirtyPreferences = {};
		}

		initialize(glassContext) {
			this._glassContext = glassContext;
			this._api = APIFactory.createAPI(this, [DashboardPreferencesAPI]);
			this._userProfile = glassContext.getCoreSvc('.UserProfile');
			this._logger = glassContext.getCoreSvc('.Logger');
			this._preferences = this._userProfile.preferences;
		}

		getAPI() {
			return this._api;
		}

		getPreference(name) {
			return this._preferences[name];
		}

		_isValidValue(value) {
			return value === null || typeof value === 'boolean' || typeof value === 'string' || typeof value === 'number';
		}

		setPreference(name, value) {
			if(this._isValidValue(value)) {
				this._preferences[name] = value;
				this._dirtyPreferences[name] = value;
			} else {
				throw new Error('Invalid value type', value);
			}
		}

		savePreferences() {
			let response;
			if (Object.keys(this._dirtyPreferences).length === 0) {
				this._logger.info('No preferences to save to CM');
				response = Promise.resolve();
			} else {
				response = this._userProfile.savePreferences(this._dirtyPreferences).then(() => {
					this._dirtyPreferences = {};
				});
			}
			return response;
		}
	}
	return CADashboardPreferences;
});
